import React from 'react'
import './imagecard.css'

const ImageCard = ({imgsrc}) => {
  return (
    <div className='snap_card'>
      <div className='snap_img__container'>
        <img className='snap-img' src={imgsrc} alt='card'/>
      </div>
    </div>
  )
}

export default ImageCard